const Footer = () => {
  return (
    <div className="flex items-center justify-center min-h-40 w-full bg-slate-950 text-zinc-100">
      <p className="">Praca inżynierska Tomasz Zimoń & Łukasz Zygar</p>
    </div>
  );
};

export default Footer;
